export default __webpack_public_path__ + "feedback-1200-5d1dd4c3d027f356726fdb4ab0c71a97.webp";